/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCalendar16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M4.25 5.5a.5.5 0 01-.5-.5V3.5H2.367a.88.88 0 00-.867.889V7h13V4.389a.88.88 0 00-.867-.889H12.25V5a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5V3.5h-5.5V5a.5.5 0 01-.5.5h-.5zm6.5-3.5h-5.5V.5a.5.5 0 00-.5-.5h-.5a.5.5 0 00-.5.5V2H2.367C1.03 2 0 3.092 0 4.38v9.235C0 14.903 1.031 16 2.367 16h11.266C14.97 16 16 14.903 16 13.615V4.38C16 3.092 14.969 2 13.633 2H12.25V.5a.5.5 0 00-.5-.5h-.5a.5.5 0 00-.5.5V2zm3.75 6.5h-13v5.115c0 .489.388.885.867.885h11.266a.876.876 0 00.867-.885V8.5z'
      />
    </svg>
  );
}

export default SvgCalendar16;
